<style>
@import "../account.scss";
</style>

<script>
import { EventBus } from '../../../event-bus'
import ConsumerService from '../account-consumer.service'
import countryCodes from '../../../data/countryCodes.json'

const consumerService = new ConsumerService()

export default {
  name: 'ConsumerRegister',
  data () {
    return {
      consumer: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        password: '',
        countryCode: 'US +1',
        nationalIdentifier: (this.$store.state.configuration.checkout || {}).nationalIdentifier || ''
      },
      submitted: false,
      errorMessage: false,
      successMessage: false,
      countryCodes: countryCodes
    }
  },

  computed: {
    seletedCountry: function () {
      let selectedCode = this.consumer.countryCode.split(' ')[0]
      return this.countryCodes.find(item => item.code === selectedCode)
    }
  },

  methods: {
    /**
     * This method will call Register Api with valid details
     * @param e
     */
    handleSubmit (e) {
      this.submitted = true
      this.$validator.validate().then(valid => {
        if (valid) {
          consumerService.register(this.consumer).then(res => {
            this.successMessage = 'Registration completed successfully.'
            setTimeout(() => {
              this.successMessage = false
              this.goToLogin()
            }, 3000)
          }).catch(error => {
            this.errorMessage = error
            setTimeout(() => {
              this.errorMessage = false
            }, 3000)
          })
        }
      })
    },

    /**
     * This method will route to login page
     */
    goToLogin () {
      EventBus.$emit('switchConsumerPage', 'consumerLogin')
    }
  }
}
</script>

<template>
  <div
    id="consumer-register"
    class="py-5"
  >
    <div
      v-if="successMessage"
      class="alert alert-primary mx-auto col-sm-12 col-md-10"
      role="alert"
    >
      {{ successMessage }}
    </div>
    <div
      v-if="errorMessage"
      class="alert alert-danger mx-auto col-sm-12 col-md-10"
      role="alert"
    >
      {{ errorMessage }}
    </div>
    <h5 class="text-center">
      {{ $t ('label.consumerRegistration') }}
    </h5>
    <div class="src-user-icon mt-4 mb-5">
      <i class="fa fa-user-circle-o text-primary fa-5x" />
    </div>
    <form @submit.prevent="handleSubmit">
      <div class="form-group mx-auto col-sm-12 col-md-8">
        <input
          v-validate="{ required: true, min: 2 }"
          id="consumerFirstName"
          v-model="consumer.firstName"
          :class="{ 'is-invalid': submitted && errors.has('firstName') }"
          name="firstName"
          placeholder="First name"
          type="text"
          class="form-control"
        >
        <div
          v-if="submitted && errors.has('firstName')"
          class="invalid-feedback">{{ errors.first('firstName') }}</div>
      </div>
      <div class="form-group mx-auto col-sm-12 col-md-8">
        <input
          v-validate="{ required: true, min: 2 }"
          id="consumerLastName"
          v-model="consumer.lastName"
          :class="{ 'is-invalid': submitted && errors.has('lastName') }"
          name="lastName"
          placeholder="Last name"
          type="text"
          class="form-control"
        >
        <div
          v-if="submitted && errors.has('lastName')"
          class="invalid-feedback">{{ errors.first('lastName') }}</div>
      </div>
      <div class="form-group mx-auto col-sm-12 col-md-8">
        <select
          id="consumerCountryCode"
          v-model="consumer.countryCode"
          class="form-control d-lg-inline col-sm-12 col-lg-4"
          name="countryCode"
        >
          <option
            v-for="(codes,index) in countryCodes"
            :key="index"
            :value="codes.code +' '+ codes.dial_code"
          >
            {{ codes.code.concat(" ", codes.dial_code) }}
          </option>
        </select>
        <input
          v-validate="{ required: true, regex:'^\\d+$', min: seletedCountry.minimumLength, max:seletedCountry.maximumLength }"
          id="consumerPhoneNumber"
          v-model="consumer.phoneNumber"
          :class="{ 'is-invalid': submitted && errors.has('phoneNumber') }"
          name="phoneNumber"
          placeholder="Phone number"
          type="number"
          class="form-control d-lg-inline col-sm-12 col-lg-8"
        >
        <div
          v-if="submitted && errors.has('phoneNumber')"
          class="invalid-feedback">{{ errors.first('phoneNumber') }}</div>
      </div>
      <div class="form-group mx-auto col-sm-12 col-md-8">
        <input
          v-validate="{ required: true, email: true }"
          id="consumerEmail"
          v-model="consumer.email"
          :class="{ 'is-invalid': submitted && errors.has('email') }"
          name="email"
          placeholder="Email address"
          type="email"
          class="form-control"
        >
        <div
          v-if="submitted && errors.has('email')"
          class="invalid-feedback">{{ errors.first('email') }}</div>
      </div>
      <div class="form-group mx-auto col-sm-12 col-md-8">
        <input
          v-validate="{ required: true, min: 6 }"
          id="consumerPassword"
          v-model="consumer.password"
          :class="{ 'is-invalid': submitted && errors.has('password') }"
          type="password"
          placeholder="Password"
          name="password"
          class="form-control" >
        <div
          v-if="submitted && errors.has('password')"
          class="invalid-feedback">{{ errors.first('password') }}</div>
      </div>
      <div class="mt-4 mx-auto col-sm-8 col-md-8">
        <button class="btn btn-primary btn-block">
          {{ $t ('label.register') }}
        </button>
      </div>
      <div class="text-center mt-4">
        <a
          href="javascript:;"
          @click="goToLogin">
          {{ $t ('label.alreadyAccountLogin') }}
        </a>
      </div>
    </form>
  </div>
</template>
